module.exports = __webpack_public_path__ + "static/media/Lishal_cv.2ce6bc92.pdf";